import DeviceDetector from "device-detector-js";
import { Notifier } from "@airbrake/browser";

window.deviceDetector = new DeviceDetector();
window.device = window.deviceDetector.parse(navigator.userAgent);

if (!window.device.bot && window.env.JEKYLL_ENV === "production") {
  try {
    window.airbrake = new Notifier({
      projectId: window.env.AIRBRAKE_PROJECT_ID,
      projectKey: window.env.AIRBRAKE_PROJECT_KEY,
      host: "https://panel.sutty.nl",
    });

    console.originalError = console.error;
    console.error = (...e) => {
      window.airbrake.notify(e.join(" "));
      return console.originalError(...e);
    };
  } catch (e) {
    console.error(e);
  }
}

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();

import DeviceDetectorController from "./controllers/device_detector_controller";
import ScrollController from "./controllers/scroll_controller";
import ScrollIllustrationController from "./controllers/scroll_illustration_controller";
import MenuController from "./controllers/menu_controller";
import SwiperController from "./controllers/swiper_controller";
import PagefindController from "./controllers/pagefind_controller";
import SortingController from "./controllers/sorting_controller";
import PopupController from "./controllers/popup_controller";
import ClassesTogglerController from "./controllers/classes_toggler_controller";
import ContactController from "./controllers/contact_controller";

Stimulus.debug = window.env.JEKYLL_ENV !== "production";
Stimulus.register("device-detector", DeviceDetectorController);
Stimulus.register("scroll", ScrollController);
Stimulus.register("scroll-illustration", ScrollIllustrationController);
Stimulus.register("menu", MenuController);
Stimulus.register("swiper", SwiperController);
Stimulus.register("pagefind", PagefindController);
Stimulus.register("sorting", SortingController);
Stimulus.register("popup", PopupController);
Stimulus.register("classes-toggler", ClassesTogglerController);
Stimulus.register("contact", ContactController);

document.addEventListener("turbo:load", (event) => {
  document
    .querySelectorAll("a[href^='http://'],a[href^='https://'],a[href^='//']")
    .forEach((a) => {
      a.rel = "noopener";
      a.target = "_blank";
    });
});
